import '@/config/i18n';
import initAdminUi from '@erikdakoda/admin-ui/init';
import initAgent from '@erikdakoda/agent/init';
import initAgentUi from '@erikdakoda/agent-ui/init';
import initAiTool from '@erikdakoda/ai-tool/init';
import initArtifact from '@erikdakoda/artifact/init';
import initArtifactUi from '@erikdakoda/artifact-ui/init';
import initAuthUi from '@erikdakoda/auth-ui/init';
import initBook from '@erikdakoda/book/init';
import initBookUi from '@erikdakoda/book-ui/init';
import initBot from '@erikdakoda/bot/init';
import initBotUi from '@erikdakoda/bot-ui/init';
import initCloudinaryUi from '@erikdakoda/cloudinary-ui/init';
import initCoaching from '@erikdakoda/coaching/init';
import initCoachingUi from '@erikdakoda/coaching-ui/init';
import initConnection from '@erikdakoda/connection/init';
import initConnectionUi from '@erikdakoda/connection-ui/init';
import initConvo from '@erikdakoda/convo/init';
import initConvoUi from '@erikdakoda/convo-ui/init';
import initDataGridUi from '@erikdakoda/data-grid-ui/init';
import initEditorUi from '@erikdakoda/editor-ui/init';
import initExecutionUi from '@erikdakoda/execution-ui/init';
import initHabit from '@erikdakoda/habit/init';
import initHabitUi from '@erikdakoda/habit-ui/init';
import initLabelUi from '@erikdakoda/label-ui/init';
import initMetric from '@erikdakoda/metric/init';
import initMetricUi from '@erikdakoda/metric-ui/init';
import initProgram from '@erikdakoda/program/init';
import initProgramUi from '@erikdakoda/program-ui/init';
import initMarkdownUi from '@erikdakoda/markdown-ui/init';
import initMcpServerManager from '@erikdakoda/mcp-server-manager/init';
import initMemory from '@erikdakoda/memory/init';
import initNotification from '@erikdakoda/notification/init';
import initNotificationUi from '@erikdakoda/notification-ui/init';
import initSchema from '@erikdakoda/schema/init';
import initPodcast from '@erikdakoda/podcast/init';
import initPodcastUi from '@erikdakoda/podcast-ui/init';
import initQuiz from '@erikdakoda/quiz/init';
import initQuestionUi from '@erikdakoda/question-ui/init';
import initQuizUi from '@erikdakoda/quiz-ui/init';
import initSiteTemplateUi from '@erikdakoda/site-template-ui/init';
import initTaxonomy from '@erikdakoda/taxonomy/init';
import initTaxonomyUi from '@erikdakoda/taxonomy-ui/init';
import initTodo from '@erikdakoda/todo/init';
import initTodoUi from '@erikdakoda/todo-ui/init';
import initToolSet from '@erikdakoda/tool-set/init';
import initToolSetUi from '@erikdakoda/tool-set-ui/init';
import initUi from '@erikdakoda/ui/init';
import initUser from '@erikdakoda/user/init';
import initFeedbackUi from '@erikdakoda/feedback-ui/init';
import initUserUi from '@erikdakoda/user-ui/init';
import initUtilsUi from '@erikdakoda/utils-ui/init';
import initVideoUi from '@erikdakoda/video-ui/init';
import initUvilo from '../init';
import { registerAccountSettingsTab } from '@erikdakoda/user-ui/settings/accountSettingsTabs';
import TabConnections from '@erikdakoda/metric-ui/components/TabConnections';

export default function initPackages() {
  registerAccountSettingsTab('connections', TabConnections);
  initUvilo();
  initAdminUi();
  initAiTool();
  initAgent();
  initAgentUi();
  initArtifact();
  initArtifactUi();
  initAuthUi();
  initUser();
  initBot();
  initBotUi();
  initCloudinaryUi();
  initCoaching();
  initCoachingUi();
  initConnection();
  initConnectionUi();
  initConvo();
  initConvoUi();
  initDataGridUi();
  initEditorUi();
  initExecutionUi();
  initHabit();
  initHabitUi();
  initLabelUi();
  initMetric();
  initMetricUi();
  initSchema();
  initProgram();
  initProgramUi();
  initMarkdownUi();
  initMemory();
  initMcpServerManager();
  initNotification();
  initNotificationUi();
  initPodcast();
  initPodcastUi();
  initQuiz();
  initQuestionUi();
  initQuizUi();
  initSiteTemplateUi();
  initTaxonomy();
  initTaxonomyUi();
  initBook();
  initBookUi();
  initTodo();
  initTodoUi();
  initToolSet();
  initToolSetUi();
  initUi();
  initUserUi();
  initFeedbackUi();
  initUtilsUi();
  initVideoUi();
}
